module.exports = __webpack_public_path__ + "img/tupian2.0793dbc8.svg";